import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../Header/Header";
import ProgressBar from "../../../../components/ProgressBar";
import { showErrorToast } from "../../../utils";

export default function CompanyInformation() {
    const [formData, setFormData] = useState({
        companyName: "",
        businessRegistrationNumber: "",
        country: "",
        state: "",
    });
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        if (!formData.companyName) {
            showErrorToast("Please enter company name");
            return;
        }
        if (!formData.businessRegistrationNumber) {
            showErrorToast("Please enter business registration number");
            return;
        }
        if (!formData.country) {
            showErrorToast("Please enter country");
            return;
        }
        if (!formData.state) {
            showErrorToast("Please enter state");
            return;
        }
        try {
            e.preventDefault();
            navigate("/company-verification/owner-documents", {
                state: {
                    formData,
                },
            });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className="tw-flex tw-w-full tw-pt-[70px] tw-flex-col tw-h-screen tw-items-center tw-px-[20px] max-sm:tw-px-4">
            <Header title={"Identity Verification"} />
            <ProgressBar currentStep={1} totalSteps={3} />
            <div className="tw-flex tw-flex-col tw-w-full tw-mt-20 max-sm:tw-mt-10 tw-px-20 max-sm:tw-px-4 tw-max-w-4xl">
                <div className="tw-bg-white tw-rounded-md tw-p-5 max-sm:tw-p-4">
                    <p className="tw-text-black tw-text-[28px] max-sm:tw-text-[22px] tw-font-bold tw-text-center tw-border-b tw-boder-border_color tw-py-4 max-sm:tw-py-3">
                        Company Information
                    </p>
                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-w-full tw-gap-10 max-sm:tw-gap-6 tw-mt-10 max-sm:tw-mt-6">
                        <div className="tw-w-full md:tw-w-1/2">
                            <p className="tw-text-black tw-font-medium tw-mb-2">Company Name</p>
                            <input
                                type="text"
                                value={formData.companyName}
                                maxLength={150}
                                onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                                className="tw-w-full tw-border tw-mt-3 max-sm:tw-mt-2 tw-border-border_color tw-rounded-md tw-py-2 tw-px-4 max-sm:tw-py-3 tw-text-sm max-sm:tw-text-base"
                                placeholder="Enter Company Name"
                            />
                        </div>
                        <div className="tw-w-full md:tw-w-1/2">
                            <p className="tw-text-black tw-font-medium tw-mb-2">Business Registration Number</p>
                            <input
                                type="number"
                                value={formData.businessRegistrationNumber}
                                onChange={(e) => {
                                    if (e.target.value.length > 25) return; // Limit to 15 digits
                                    setFormData({ ...formData, businessRegistrationNumber: e.target.value });
                                }}
                                className="tw-w-full tw-border tw-mt-3 max-sm:tw-mt-2 tw-border-border_color tw-rounded-md tw-py-2 tw-px-4 max-sm:tw-py-3 tw-text-sm max-sm:tw-text-base"
                                placeholder="Enter Reg. Number"
                            />
                        </div>
                    </div>
                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-w-full tw-gap-10 max-sm:tw-gap-6 tw-mt-10 max-sm:tw-mt-6">
                        <div className="tw-w-full md:tw-w-1/2">
                            <p className="tw-text-black tw-font-medium tw-mb-2">Country</p>
                            <input
                                type="text"
                                value={formData.country}
                                maxLength={50}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        country: e.target.value.replace(/[^A-Za-z\s]/g, ""), // removes invalid chars
                                    })
                                }
                                className="tw-w-full tw-border tw-mt-3 max-sm:tw-mt-2 tw-border-border_color tw-rounded-md tw-py-2 tw-px-4 max-sm:tw-py-3 tw-text-sm max-sm:tw-text-base"
                                placeholder="Enter Country"
                            />
                        </div>

                        <div className="tw-w-full md:tw-w-1/2">
                            <p className="tw-text-black tw-font-medium tw-mb-2">State</p>
                            <input
                                type="text"
                                value={formData.state}
                                maxLength={50}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        state: e.target.value.replace(/[^A-Za-z\s]/g, ""), // removes invalid chars
                                    })
                                }
                                className="tw-w-full tw-border tw-mt-3 max-sm:tw-mt-2 tw-border-border_color tw-rounded-md tw-py-2 tw-px-4 max-sm:tw-py-3 tw-text-sm max-sm:tw-text-base"
                                placeholder="Enter State"
                            />
                        </div>
                    </div>
                    <div className="tw-flex tw-justify-center tw-w-full">
                        <button
                            onClick={handleSubmit}
                            className="tw-flex tw-self-center tw-bg-primary tw-px-20 max-sm:tw-px-8 tw-py-3 max-sm:tw-py-4 tw-rounded-md tw-mt-10 max-sm:tw-mt-8 tw-justify-center tw-items-center tw-text-white tw-w-full max-sm:tw-max-w-xs tw-font-medium max-sm:tw-text-base"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
